import { render, staticRenderFns } from "./PKRIcon.vue?vue&type=template&id=0c8efbfd&scoped=true&"
import script from "./PKRIcon.vue?vue&type=script&lang=js&"
export * from "./PKRIcon.vue?vue&type=script&lang=js&"
import style0 from "./PKRIcon.vue?vue&type=style&index=0&id=0c8efbfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8efbfd",
  null
  
)

export default component.exports